export class MediaQueriesManager {
    constructor() {
        this._queriesList = {};
    }
    getQueryList(queryName) {
        if (!this._queriesList[queryName]) {
            this._queriesList[queryName] = window.matchMedia(queryName);
        }
        return this._queriesList[queryName];
    }
    listen(queryName, onMatches, callback) {
        const queryList = this.getQueryList(queryName);
        queryList.addListener((list) => {
            callback(list);
        });
        callback(queryList);
    }
    matches(queryName) {
        return this.getQueryList(queryName).matches;
    }
    onMatches(queryNameList, callback) {
        queryNameList.forEach(((query) => {
            this.listen(query, false, callback);
        }));
    }
}
